// One-time codes: the numbers every surface has to agree on (spec/07 §2.2, spec/12 §3.2–3.3).
//
// "6 digits, 10-minute validity, 5 attempts … resend after 30 s" (spec/12 §3.3, issue #42 rule 3).
// The server enforces the first three; the fourth is the moment a kiosk, an app or player web
// offers "Send again", and it is here so all of them offer it at the same second.
import { z } from "../zod.js";
/** Digits in a phone or email one-time code. */
export const OTP_CODE_LENGTH = 6;
/** How long a code stays valid, in seconds (spec/12 §3.3: "10-minute validity"). */
export const OTP_LIFETIME_SECONDS = 10 * 60;
/** Wrong attempts a code survives; the next one voids it (spec/07 §2.2). */
export const OTP_ATTEMPTS_PER_CODE = 5;
/** When a client may offer to send another code, in seconds (spec/12 §3.2). */
export const OTP_RESEND_AFTER_SECONDS = 30;
export const OtpCodeSchema = z
    .string()
    .regex(/^\d{6}$/, 'Expected the 6-digit code')
    .openapi('OtpCode', { description: 'A 6-digit one-time code.', example: '482913' });
/**
 * The channels a phone one-time code can travel by. SMS is always the last resort
 * (spec/16 §1 rule 5, issue #42 rule 2).
 */
export const OTP_CHANNELS = ['sms', 'whatsapp'];
export const OtpChannelSchema = z
    .enum(OTP_CHANNELS)
    .openapi('OtpChannel', { description: 'How a one-time code is delivered.' });
/**
 * `auth.otpChannel` (spec/12 §9, spec/07 §2.1): which channels a phone code may use. `both` lets
 * `notifications.otpChannelOrder` choose, cheapest working channel first; every choice falls back
 * to SMS rather than failing (issue #42 rule 2). It never means "send on both" — OTPs never fan
 * out (spec/16 §1 rule 5).
 */
export const OTP_CHANNEL_SETTINGS = ['sms', 'whatsapp', 'both'];
export const OtpChannelSettingSchema = z.enum(OTP_CHANNEL_SETTINGS);
//# sourceMappingURL=otp.js.map